/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for joinFilterType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="joinFilterType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="none"/&gt; &lt;enumeration value="in"/&gt; &lt;enumeration value="between"/&gt; &lt;enumeration value="table"/&gt; &lt;enumeration value="flexible"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class JoinFilterType extends Enum{

	enumValue = null;

	/**
	 * No predicate is generated.
	 */
	static  NONE = JoinFilterType.newLiteral("none");

	/**
	 * Generates an IN predicate of constant values.
	 */
	static  IN = JoinFilterType.newLiteral("in");

	/**
	 * Generates a BETWEEN predicate comprised of MIN and MAX values of the join keys.
	 */
	static  BETWEEN = JoinFilterType.newLiteral("between");

	/**
	 * Generates a table row constructor form of the IN predicate.
	 */
	static  TABLE = JoinFilterType.newLiteral("table");

	/**
	 * Use values from the left table to filter the table on the right. This uses either IN predicates or BETWEEN predicates. An error is thrown if the optimization can not be applied.
	 */
	static  FLEXIBLE = JoinFilterType.newLiteral("flexible");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < JoinFilterType.values().length); ++i) {
			if (JoinFilterType.values()[i].enumValue == v) {
				return JoinFilterType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("JoinFilterType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/JoinFilterType.js